import { render } from "./uploadIcon.svg?vue&type=template&id=1a7ac52b"
const script = {}
script.render = render

export default script